export default {
  methods: {
    formatLaunchMode(launch) {
      switch (launch) {
        case 'b2b':
        case 'interface_select_bt':
          return 'Bluetooth';
        case 'interface_select':
          return 'Select';
        case 'interface_select_plus':
          return 'Select+';
        case 'interface_select_plus_plus':
          return 'Select++';
        case 'interface_prime':
          return 'Prime';
        default:
          break;
      }
    },
  },
};
